import { playHaptic } from "core/javascriptChannels";
import { useCallback, useEffect } from "react";
import { ReactComponent as JournalBook } from "shared/assets/journal-book.svg";
import { Animations } from "../../../../hooks/useAnimation/animations.enum";
import { useAnimation } from "../../../../hooks/useAnimation/useAnimation";
import PageModal from "UIPalette/PageModal/PageModal";
import { useTranslation } from "react-i18next";
import { useAppReviewContext } from "core/state/AppReviewContext/AppReviewContext";

export const JournalLogged = ({ handleNavigation }: { handleNavigation: () => void }) => {
  const { t } = useTranslation(undefined, { keyPrefix: "positiveYou.journalForm" });
  const { trigger: animateWiggle, targetRef: bookRef, isAnimating: isAnimatingWiggle } = useAnimation(Animations.Wiggle);
  const { handlePositiveMoment } = useAppReviewContext();

  const runWiggleFeedback = useCallback(() => {
    if (bookRef.current && !isAnimatingWiggle.current) {
      playHaptic();
      animateWiggle();
    }
  }, [animateWiggle, bookRef, isAnimatingWiggle]);

  useEffect(() => {
    runWiggleFeedback();
    setTimeout(() => {
      handleNavigation();
      handlePositiveMoment();
    }, 2000);
  }, [handleNavigation, handlePositiveMoment, runWiggleFeedback]);

  return (
    <PageModal showMobileIcon={false} hideBackForDesktop>
      <div className="text-center flex flex-col items-center h-full justify-center space-y-8">
        <div ref={bookRef}>
          <JournalBook />
        </div>
        <p className="font-bold">{t("saved")}</p>
      </div>
    </PageModal>
  );
};
